<template>
    <section>
        <div class="py-5 ">
            <div class="container" >
                <div class="row">
                    <div  class="row mb-3">
                        <div class="alert alert-danger" role="alert">
                            {{errorMsg}}                      
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
  export default {
   name: 'MsgComp',
   props: {
    errorMsg: String
  },
  }
</script>